import { Options } from "./Options";

export const wellOptions: Options[] = [
    {
      wellId: '60b66a917ff4e83d141e4f8a',
      wellName: 'Select Well Name',
      assetGroupName: ''
    },
  ];